import { Convert } from '@itus/ui.common'
import { RiskAnalysisFailureModeModel } from './risk-analysis-failure-mode-model'

export class RiskAnalysisAssetModel {
  constructor(data) {
    data = data || {}
    this.id = Convert.toString(data.id, null)
    this.improvement = Convert.toBoolean(data.improvement, false)
    this.improvementComment = Convert.toString(data.improvementComment, null)
    this.probabilityValue = Convert.toFloat(data.probabilityValue, null)
    this.failureModes = data.failureModes ? data.failureModes.map(x => new RiskAnalysisFailureModeModel(x)) : []
  }
}
export default { RiskAnalysisAssetModel }
